import React from 'react';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { ContentrArea } from '@ttstr/components';

const Videos: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article>
      <Container className="list-page my-5">
        <Helmet>
          <title>Videos</title>
          <body className="videos-page" />
        </Helmet>
        <h1 className="mb-5">Videos</h1>
        <ContentrArea id="videos-page-content" />
        <Container fluid className="px-0">
          <div className="video-responsive mt-5">
            <iframe
              src={`https://www.youtube.com/embed/05h_ySRLBx4?si=tvh_PEunNww252Qk`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Embedded youtube"
            />
          </div>

          <div className="video-responsive mt-5">
            <iframe
              src={`https://www.youtube.com/embed/7jfxcDudvS8?si=Zb3FmwYTi5uHXWyw`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Embedded youtube"
            />
          </div>

          <div className="video-responsive mt-5">
            <iframe
              src={`https://www.youtube.com/embed/07D2rMuO4mo?si=KvpmaHyKHy9VoNJR`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Embedded youtube"
            />
          </div>

          <div className="video-responsive mt-5">
            <iframe
              src={`https://www.youtube.com/embed/_55Agc3Q6zg?si=YBEHei7j94ROnZ-h`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="Embedded youtube"
            />
          </div>
        </Container>
      </Container>
    </article>
  );
};

export default React.memo(Videos);
